import React from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import CanvasPage from './pages/CanvasPage';
import PromptManagerPage from './pages/PromptManagerPage';
import ChatPage from './pages/ChatPage';
import WorkflowsPage from './pages/WorkflowsPage';
import PrototyperPage from './pages/PrototyperPage';
import ToneShiftPage from './pages/ToneShiftPage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import { AuthProvider, useAuth } from './context/AuthContext';
import { NavProvider } from './context/NavContext';
import PrivateRoute from './components/PrivateRoute';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import SharedContentPage from './pages/SharedContentPage';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './styles/App.css';

const PublicRoute = ({ children }) => {
  const { user } = useAuth();
  if (user) {
    return <Navigate to="/" />;
  }
  return children;
};

function App() {
  return (
    <AuthProvider>
      <NavProvider>
        <Router>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable={false}
          pauseOnHover
          theme="light"
        />
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={
            <PublicRoute>
              <LoginPage />
            </PublicRoute>
          } />
          <Route path="/signup" element={
            <PublicRoute>
              <SignupPage />
            </PublicRoute>
          } />
          <Route path="/forgot-password" element={
            <PublicRoute>
              <ForgotPasswordPage />
            </PublicRoute>
          } />
          <Route path="/reset-password/:token" element={
            <PublicRoute>
              <ResetPasswordPage />
            </PublicRoute>
          } />
          <Route path="/share/:shareId" element={<SharedContentPage />} />

          {/* Private Routes */}
          <Route path="/*" element={
            <PrivateRoute>
              <Layout>
                <Routes>
                  {/* <Route path="/" element={<HomePage />} /> */}
                  <Route path="/" element={<CanvasPage />} />
                  <Route path="/canvas" element={<CanvasPage />} />
                  <Route path="/prompt-manager" element={<PromptManagerPage />} />
                  <Route path="/tone-shift" element={<ToneShiftPage />} />
                  <Route path="/chat" element={<ChatPage />} />
                  <Route path="/workflows" element={<WorkflowsPage />} />
                  <Route path="/prototyper" element={<PrototyperPage />} />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </Layout>
            </PrivateRoute>
          } />
        </Routes>
      </Router>
        </NavProvider>
    </AuthProvider>
  );
}

export default App;
